<template>
  <div class="operationRecord">
    <el-form ref="form" :model="request" label-position="right">
      <el-form-item><el-input v-model="request.orderId" placeholder="订单号" style="width:200px" clearable></el-input></el-form-item>
       <el-form-item><el-input v-model="request.deviceId" placeholder="设备编号" style="width:200px" clearable></el-input></el-form-item>
       <el-form-item>
         <el-select v-model="request.type">
            <el-option v-for="item in global.oam_type" :key="item.code" :label="item.message" :value="item.code"></el-option>
          </el-select>
       </el-form-item>
       <el-form-item>
          <el-date-picker v-model="time" type="daterange" :append-to-body="false" range-separator="至" start-placeholder="开始日期" 
          end-placeholder="结束日期" @change="chooseTime" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getAllOam()">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset()">重置</el-button>
        </el-form-item>
    </el-form>
    <div class="tableData">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                style="margin:auto;width:calc(100% - 30px)" height="730" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="订单号"  align="center" prop="orderId"></el-table-column>
        <el-table-column label="设备编号" align="center" prop="deviceId"></el-table-column>
        <el-table-column label="订单状态" align="center" prop="stateStr"></el-table-column>
        <el-table-column label="操作类型" align="center" prop="typeStr"></el-table-column>
        <el-table-column label="操作原因" align="center" prop="reason"></el-table-column>
        <el-table-column label="操作人" align="center" prop="userName"></el-table-column>
        <el-table-column label="操作时间" align="center">
          <template slot-scope="scope">
            {{scope.row.createTime | formatDate}}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    </div>
  </div>
</template>

<script>
import {getOamRecord} from '../../api/oder/operationrecord.js'
import {formatDate} from "../../utils/date";
export default {
  name: 'OperationRecord',
  data() {
    return {
      request: {
        orderId: '',
        deviceId: '',
        type: '',
        startTime: '',
        endTime: '',
        current: '',
        size: ''
      },
      time: '',
      query: {current: 1, size: 20},
      response: {data: [],total: 0},
      global: '',
      loading: false,
    }
  },
  methods: {
    /**
     * 时间选择触发事件
     */
    chooseTime(events){
      this.request.startTime = events[0];
      this.request.endTime = events[1];
    },

    /**
     * 查询订单运维列表
     */
    getAllOam(){
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getOamRecord(this.request).then(result => {
        this.response.data = result.data.records;
          this.response.total = result.data.total;
      })
    },

    /**
     * 页码改变触发事件
     */
    currenChangeHandle(value){
      this.request.current = value;
      this.getAllOam();
    },

    /**
     * 重置
     */
    reset(){
      this.request.orderId = '';
      this.request.deviceId = '';
      this.request.type = '';
      this.request.startTime = '';
      this.request.endTime = '';
      this.request.current = 1;
      this.request.size = 10;
      this.getAllOam();
    }
  },
  created() {
    this.global = JSON.parse(sessionStorage.getItem("global"));
    this.getAllOam();
  },
filters: {
  formatDate(time) {
    var date = new Date(time);
    return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
  }
}
}
</script>

<style scoped>
.operationRecord {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}

.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ordermanagement/operationrecord.vue